export const aiInspectorId = 'ai-assistance'
